<template>
  <div class="confirm-container">
    <div v-if="firstStep && !props.skipFirstStep">
      <p>{{props.infoText}}</p>
      <button type="button" class="btn btn-danger" @click="firstStep = false;">{{props.buttonLabel}}</button>
    </div>
    
    <div v-if="!firstStep || props.skipFirstStep">
      <div class="form-group">
        <label for="entityId">{{props.confirmText}}</label>
        <input 
          type="text" 
          class="form-control center" 
          id="entityId" 
          aria-describedby="entityIdHelp"
          v-model="enteredEntityId"
          autocomplete="off"
>
        <small id="entityIdHelp" class="form-text text-muted">{{props.confirmHelp}}</small>
      </div>
      <div class="button-container">
        <button
          type="button" class="btn btn-danger btn-sm" 
          :disabled="enteredEntityId !== props.entityId"
          @click="raiseEvent()"
          ><font-awesome-icon v-if="props.buttonIcon" :icon="props.buttonIcon"/> {{props.buttonLabel}}</button>

        <button
          type="button" class="btn btn-light btn-sm" 
          @click="cancelEvent()"
          ><font-awesome-icon icon="times"/> Cancel</button>
      </div>

      <Error v-if="props.errorMessage" :label="props.errorMessage"/>
      <Success v-if="props.successMessage" :label="props.successMessage"/>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  entityId?: string;
  infoText?: string;
  buttonLabel?: string;
  buttonIcon?: string;
  confirmText?: string;
  confirmHelp?: string;
  successMessage?: string;
  errorMessage?: string;
  skipFirstStep?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  entityId: '',
  infoText: '',
  buttonLabel: '',
  buttonIcon: '',
  confirmText: '',
  confirmHelp: '',
  successMessage: '',
  errorMessage: '',
  skipFirstStep: false
});

const emit = defineEmits<{
  'action-confirmed': [entityId: string];
  'action-cancelled': [entityId: string];
}>();

const firstStep = ref(true);
const enteredEntityId = ref('');

function raiseEvent() {
  emit('action-confirmed', props.entityId);
}

function cancelEvent() {
  firstStep.value = true;
  emit('action-cancelled', props.entityId);
}
</script>

<style scoped lang="scss">

.confirm-container {
  margin-right: auto;
  margin-left: auto;
}

.form-control.center {
  text-align: center;
}

.button-container button {
  margin:5px;
}
</style>